import { render, staticRenderFns } from "./CreateGiveaway.vue?vue&type=template&id=01c51d8d"
import script from "./CreateGiveaway.vue?vue&type=script&lang=js"
export * from "./CreateGiveaway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports